import Swipe from 'swipe-js-iso';

class GallerySlider {
    constructor() {
        this.sliders = [];
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initializeSliders();
        });
    }

    initializeSliders() {
        const galleries = document.querySelectorAll('.wp-block-gallery.slider, .gallery.slider');
        
        galleries.forEach((gallery, index) => {
            this.convertToSlider(gallery, index);
        });
    }

    convertToSlider(gallery, index) {
        const galleryItems = gallery.querySelectorAll('.wp-block-image, .gallery-item');
        
        if (galleryItems.length <= 1) {
            return; // No need for slider with single image
        }

        const sliderId = `gallery-slider-${index}`;
        gallery.id = sliderId;

        // Create slider wrapper
        const sliderWrapper = document.createElement('div');
        sliderWrapper.className = 'gallery-slider-wrapper';

        // Create slider container
        const sliderContainer = document.createElement('div');
        sliderContainer.className = 'gallery-slider-container';

        // Create slides wrapper
        const slidesWrapper = document.createElement('div');
        slidesWrapper.className = 'gallery-slider-slides';

        // Convert gallery items to slides
        galleryItems.forEach((item) => {
            const slide = document.createElement('div');
            slide.className = 'gallery-slide';
            
            // Clone the item content
            const itemClone = item.cloneNode(true);
            slide.appendChild(itemClone);
            
            slidesWrapper.appendChild(slide);
        });

        // Build slider structure
        sliderContainer.appendChild(slidesWrapper);
        sliderWrapper.appendChild(sliderContainer);

        // Create dot navigation
        const dotsContainer = this.createDotNavigation(galleryItems.length, sliderId);
        sliderWrapper.appendChild(dotsContainer);

        // Replace original gallery with slider
        gallery.innerHTML = '';
        gallery.appendChild(sliderWrapper);

        // Initialize Swipe
        this.initializeSwipe(sliderContainer, dotsContainer, sliderId);
    }

    createDotNavigation(itemCount, sliderId) {
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'gallery-slider-dots';

        for (let i = 0; i < itemCount; i++) {
            const dot = document.createElement('button');
            dot.className = `gallery-dot ${i === 0 ? 'active' : ''}`;
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.dataset.slide = i;
            
            dotsContainer.appendChild(dot);
        }

        return dotsContainer;
    }

    initializeSwipe(container, dotsContainer, sliderId) {
        const swipeOptions = {
            startSlide: 0,
            speed: 400,
            auto: 5000,
            continuous: true,
            disableScroll: false,
            stopPropagation: false,
            callback: (index) => {
                this.updateDots(dotsContainer, index);
            },
            transitionEnd: (index) => {
                // Additional callback when transition ends
                this.updateDots(dotsContainer, index);
            }
        };

        const swipeInstance = new Swipe(container, swipeOptions);
        
        // Store reference for cleanup if needed
        this.sliders.push({
            id: sliderId,
            instance: swipeInstance,
            container: container
        });

        // Add dot click handlers
        const dots = dotsContainer.querySelectorAll('.gallery-dot');
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                swipeInstance.slide(index);
                this.updateDots(dotsContainer, index);
            });
        });

        // Add keyboard navigation
        container.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                swipeInstance.prev();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                swipeInstance.next();
            }
        });

        // Make container focusable for keyboard navigation
        container.setAttribute('tabindex', '0');
        container.setAttribute('role', 'region');
        container.setAttribute('aria-label', 'Image gallery slider');
    }

    updateDots(dotsContainer, activeIndex) {
        const dots = dotsContainer.querySelectorAll('.gallery-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
        });
    }

    dispose() {
        // Clean up all slider instances
        this.sliders.forEach(slider => {
            if (slider.instance && typeof slider.instance.kill === 'function') {
                slider.instance.kill();
            }
        });
        this.sliders = [];
    }
}

export default GallerySlider;